import React, { useState } from 'react';
import { Select, FormControl, FormLabel } from 'components/core';

type UncontrolledProps = {
  name: string;
  options: string[];
  error?: string;
  label?: string;
  detailsId?: string;
};

type ControlledProps = {
  onChange: (value: string) => void;
  value: string;
  options: string[];
  error?: string;
  label?: string;
  detailsId?: string;
};

export type Props = UncontrolledProps | ControlledProps;

const CitationImportSourceDropDown = (props: Props) => {
  const { options, error, label, detailsId } = props;
  const [internalValue, setInternalValue] = useState<string>('');

  // Determine value and onChange based on controlled vs uncontrolled
  const isControlled = 'onChange' in props;
  const value = isControlled ? props.value : internalValue;
  const name = isControlled ? undefined : props.name;

  const handleOnChange = (e: React.FormEvent<HTMLSelectElement>) => {
    if (isControlled) {
      props.onChange(e.currentTarget.value);
    } else {
      setInternalValue(e.currentTarget.value);
    }
  };

  return (
    <FormControl error={error}>
      {label && <FormLabel size="sm">{label}</FormLabel>}
      <Select
        value={value}
        name={name}
        onChange={handleOnChange}
        data-testid="citationSourcesDropdown"
        aria-details={detailsId}
      >
        <option value="" disabled={!value}>
          Select...
        </option>
        {options.map((source, index) => (
          <option key={index} value={source}>
            {source}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default CitationImportSourceDropDown;
